import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { League } from '../../../../models/leagues/league.model';

@Component({
  selector: 'app-league-edit-modal',
  templateUrl: './league-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LeagueEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  leagues: League[] = [];
  leagueId: number = 0;
  name: string = '';
  tier: number = 0;
  leaguePreviousId: number = null;
  leagueNextId: number = null;
  freeCreditsBonus: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiLeaguesService: ApiLeaguesService, private alertsService: AlertsService) {}

  show(league: League, allLeagues: League[], callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.leagues = allLeagues;
    this.leagueId = league.leagueId;
    this.name = league.name;
    this.tier = league.tier;
    this.leaguePreviousId = league.leaguePreviousId || null;
    this.leagueNextId = league.leagueNextId || null;
    this.freeCreditsBonus = league.freeCreditsBonus;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLeaguesService.editLeague(this.leagueId, this.name, this.tier, this.leaguePreviousId, this.leagueNextId, this.freeCreditsBonus).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('League updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating league : ' + error);
      }
    );
  }
}
